T.CorporateForm = Class(
	/**
	 * @lends {T.CorporateForm#}
	 */
	{

		METHOD: '',
		_msgId: 0,

		__construct(par = {}) {
			this.par = {
				...{
					type: 'CorporateForm',
					ref: ''
				},
				...par
			};
			this.node = mkE({
				tag: 'form',
				id: 'CorporateForm',
				className: 'bs-form',
				method: 'post',
				onsubmit: this._onSubmit
			});
			this.rpc = new RPC('/api/web_rpc.php');
			this._fields = {};
			this.draw();
		},

		/** @abstract */
		draw() {
		},

		name(attr = {}) {
			return this._fields['full_name'] = new T.BS.Input({
				placeholder: t('corporate-form.name'),
				name: 'full_name',
				attr: {
					...{
						autocomplete: 'name'
					},
					...attr,
				}
			});
		},

		email(attr = {}) {
			return this._fields['email'] = new T.BS.Input({
				placeholder: t('corporate-form.email'),
				name: 'email',
				type: 'email',
				attr: {
					...{
						autocomplete: 'name'
					},
					...attr,
				}
			});
		},

		participants(attr = {}) {
			return {
				tag: 'div',
				className: 'row form__range',
				els: [
					{
						tag: 'label',
						className: 'form-group form-group-range',
						els: [
							{
								tag: 'span',
								text: t('contacts.form.participants')
							},
							this._participantsRange = mkE({
								tag: 'input',
								type: 'range',
								step: 1,
								oninput: (e) => {
									const v = Number(e.currentTarget.value);
									let str = v >= attr.max ? `${attr.max}+` : String(v);
									this._fields['participants'].value(str);
								},
								attr: attr,
								value: attr.value || null
							})
						]
					},
					this._fields['participants'] = new T.BS.Input({
						onChange: () => {
							let v = Number(this._fields['participants'].value()) || Number(attr.min);
							v = Math.min(Math.max(v, attr.min || 0), attr.max || Infinity) || '';
							let str = v >= attr.max ? `${attr.max}+` : String(v);
							this._fields['participants'].value(str);
							this._participantsRange.value = v;
						},
						attr: attr,
						required: true,
						placeholder: t('contacts.form.participants'),
						value: attr.value || null
					})
				]
			};
		},

		message(attr = {}) {
			return this._fields['message'] = new T.BS.Textarea({
				placeholder: t('corporate-form.message'),
				name: 'message',
				attr: attr,
				required: true
			});
		},

		phone(attr = {}) {
			return this._fields['phone'] = new T.BS.Input({
				placeholder: t('corporate-form.phone'),
				name: 'phone_default',
				type: 'tel',
				phone: {
					hiddenInput: function() {
						return 'phone';
					},
					preferredCountries: t('corporate-form.phone.preffered').split(',')
				},
				attr: {
					...{
						autocomplete: 'phone'
					},
					...attr,
				}
			});
		},

		country(attr = {}) {
			return this._fields['country'] = new T.BS.Input({
				placeholder: t('corporate-form.country'),
				name: 'country_default',
				className: 'form-country',
				phone: {
					hiddenInput: function() {
						return 'country';
					},
					preferredCountries: t('corporate-form.country.preffered').split(','),
					onChange: () => {
						const country = this._fields['country'].iti.getSelectedCountryData();
						if (country) {
							this._fields['country'].value(country.name);
						}
					}
				},
				attr: attr
			});
		},

		footer() {
			return {
				tag: 'div',
				className: 'bs-row',
				els: [
					{
						tag: 'div',
						className: 'col-12 col-md-6',
						els: [
							{
								tag: 'div',
								className: 'form-disclaimer',
								els: [
									this._agreed = new T.BS.Checkbox({
										name: 'agree',
										onChange: this._onChangeAgree,
										label: {
											tag: 'span',
											els: [
												t('corporate-form.personal-data'),
												' ',
												{
													tag: 'a',
													text: t('corporate-form.privacy-policy'),
													target: '_blank',
													href: D.url('privacy-policy')
												}
											]
										}
									})
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'col-12 col-md-6',
						els: [
							{
								tag: 'div',
								className: 'form-button',
								els: [
									this._formMessage = mkE({
										tag: 'div',
										className: 'form-message'
									}),
									this._button = mkE({
										tag: 'button',
										className: 'button button-pink',
										text: t('corporate-form.send'),
										disabled: true
									})
								]
							}
						]
					}
				]
			};
		},

		_onChangeAgree() {
			this._button.disabled = !this._agreed.checked();
		},

		showError(errors) {
			let hasError = false;
			if (errors.message) {
				this._fields['message'].error(t('corporate-form.errors.message'));
				hasError = true;
			}
			if (errors.full_name) {
				this._fields['full_name'].error(t('corporate-form.errors.name'));
				hasError = true;
			}
			if (errors.phone) {
				this._fields['phone'].error(t('corporate-form.errors.phone'));
				hasError = true;
			}
			if (errors.participants) {
				this._fields['participants'].error(t('corporate-form.errors.participants'));
				hasError = true;
			}
			if (errors.country) {
				this._fields['country'].error(t('corporate-form.errors.country'));
				hasError = true;
			}
			if (errors.email) {
				this._fields['email'].error(t('corporate-form.errors.email'));
				hasError = true;
			}
			if (hasError) {
				this._scrollToError();
				return true;
			}
			return false;
		},

		_onSubmit(e) {
			e.preventDefault();
			if (this._isSubmitting) {
				return;
			}
			clearNode(this._formMessage);
			this._isSubmitting = true;
			let data = {
				type: this.par.type,
				ref: this.par.ref || ''
			};
			let errors = {};
			for (const field in this._fields) {
				const input = this._fields[field];
				if (input.checkValidity()) {
					this._fields[field].error(null);
					data[field] = input.value();
				} else {
					errors[field] = true;
				}
			}
			if (this.showError(errors)) {
				return;
			}
			this._lastData = data;
			this.rpc.send(this.METHOD, data, this._onSubmitRe);
		},

		_onSubmitRe(re) {
			this._isSubmitting = false;
			if (re.errors) {
				this.showError(re.errors);
				return;
			} else if (!re.ok) {
				alert(t('corporate-form.errors.default'));
				return;
			}
			this._msgId = Number(re.id);
			//this.showSuccess();
			this.node.reset();
			this.showPopup();

			const get = new Get();
			get.add('send-success', '');
			Section.replaceUrl(get.toUrl());
			D.gtag('generate_lead', {
				ecommerce: {
					currency: 'EUR',
					value: 0,
					lead_source: window.location.href
				}
			}, {
				email: this._lastData.email || null,
				firstName: this._lastData.full_name || null,
				phone: this._lastData.phone || null,
			});
		},

		_scrollToError() {
			let error = this.node.querySelector('.invalid-feedback:not(:empty)').closest('.form-group');
			if (error) {
				D.scrollIntoView(error);
			}
		},

		showPopup() {
			const p = new T.CorporateForm.Popup(this._onSubmitPopup);
			p.popup();
		},

		/**
		 * @param {FormData} formData
		 * @private
		 */
		_onSubmitPopup: function(formData) {
			let data = {
				id: this._msgId,
				how: formData.get('how'),
				howText: formData.get('howText')
			};
			this.rpc.send('submitContactFormAppend', data, function() {
				// Ok
			});
		}
	},
	mkE.Base
);

/**
 * @class
 * @extends mkE.Base
 */
T.CorporateForm.Popup = Class(
	/**
	 * @lends {T.CorporateForm.Popup#}
	 */
	{
		/** @type {Function} */
		onSubmit: null,
		_fields: [],
		/**
		 * @param {Function} onSubmit
		 * @private
		 */
		__construct: function(onSubmit) {
			this.onSubmit = onSubmit;
			this.node = mkE({
				tag: 'div',
				id: 'CorporateFormPopup',
				els: [
					{
						tag: 'h2',
						text: t('b2b.contacts.popup.title')
					},
					{
						tag: 'p',
						text: t('b2b.contacts.popup.subtitle')
					},
					{
						tag: 'form',
						className: 'bs-form',
						onsubmit: this._onSubmit,
						els: [
							{
								tag: 'div',
								className: 'mb-4',
								els: [
									{
										tag: 'h4',
										text: t('b2b.contacts.popup.label')
									},
									{
										tag: 'div',
										className: 'radio-list',
										els: (() => {
											let els = [];
											let options = t('b2b.contacts.popup.options').split('\n');
											for (let i = 0; i < options.length; i++) {
												const option = options[i];
												const radio = new T.BS.Radio({
													label: option,
													name: 'how',
													value: option,
													onChange: this._onHowChange
												});
												this._fields.push(radio);
												els.push(radio);
											}
											return els;
										})()
									},
									{
										tag: 'div',
										els: [
											this._howText = mkE({
												tag: 'div',
												className: 'd-none',
												els: [
													new T.BS.Input({
														name: 'howText',
														placeholder: t('b2b.contacts.popup.options.other.placeholder')
													})
												]
											})
										]
									}
								]
							},
							{
								tag: 'div',
								els: [
									this._submitBtn = mkE({
										tag: 'button',
										type: 'submit',
										className: 'button button-pink',
										text: t('b2b.contacts.popup.submit')
									})
								]
							}
						]
					}
				]
			});
		},

		_onHowChange() {
			if (this._fields[this._fields.length - 1].checked()) {
				removeClassName(this._howText, 'd-none');
			} else {
				addClassName(this._howText, 'd-none');
			}
		},

		_onSubmit(e) {
			e.preventDefault();
			this.onSubmit(new FormData(e.currentTarget));
			this._submitBtn.disabled = true;
			removeClassName(this._submitBtn, 'button-pink');
			addClassName(this._submitBtn, 'button-turquoise');
			setNodeText(this._submitBtn, t('b2b.contacts.popup.success'));
			setTimeout(() => {
				this._modal.close();
			}, 3000);
		},

		popup() {
			this._modal = new T.Popup({
				className: 'popup-contacts'
			});
			this._modal.setContent(this.node);
			this._modal.open();
		}
	},
	mkE.Base
);
